import { useEffect } from "react";

const GA_ID = "G-L7G4QTQKXZ";
const privatePath = (p) => p.replace(/^\/(visita|come-stai)\/[^/]+/, "/$1/riservato");
let lastSent = null;

export const trackConversion = (name, params = {}) =>
  window.gtag?.("event", name, { ...params, pagina_origine: privatePath(window.location.pathname) });

export const useGaPageView = (location) => {
  const { pathname, search, hash } = location;
  useEffect(() => {
    if (!window.gtag || hash?.includes("session_id=")) return;
    const page_location = window.location.origin + privatePath(pathname) + (/^\/(visita|come-stai)\//.test(pathname) ? "" : search);
    const params = { page_location, page_title: document.title };
    if (page_location === lastSent) return;
    lastSent = page_location;
    window.gtag("config", GA_ID, { ...params, send_page_view: false, update: true });
    window.gtag("event", "page_view", params);
  }, [pathname, search, hash]);
};

export const useContactClickTracking = () => {
  useEffect(() => {
    const onClick = (e) => {
      const a = e.target.closest?.('a[href*="wa.me"], a[href^="tel:"]');
      if (!a) return;
      const posizione = a.dataset.testid || a.closest("[data-testid]")?.dataset.testid || "altro";
      trackConversion(a.href.startsWith("tel:") ? "telefonata_click" : "whatsapp_click", { posizione });
    };
    document.addEventListener("click", onClick);
    return () => document.removeEventListener("click", onClick);
  }, []);
};
